import { Outlet, ScrollRestoration } from 'react-router';

/**
 * Wraps every route. `ScrollRestoration` resets the scroll offset on navigation
 * and restores it on back, which the router does not do on its own; without it a
 * tall screen opens mid-page after coming from another tall screen.
 */
export function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
